// extracted by mini-css-extract-plugin
export var reachSkipNav = "SkipNav-module--reach-skip-nav--Vn4Vw";
export var root = "SkipNav-module--root--H4vmj";